import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getManagePermissionsPage } from '../selectors';
import {
    confirmChangesAccepted,
    confirmChangesRejected,
    hidePage,
    hidePageCalled,
    managePermissionsFinished,
    selectedTabIndexChanged,
} from '../actions';
import ManagePermissionsPage from '../components/ManagePermissionsPage';

const mapStateToProps = state => getManagePermissionsPage(state);

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            onHidePage: hidePageCalled,
            onDirectHidePage: hidePage,
            onConfirmChangesAccepted: confirmChangesAccepted,
            onConfirmChangesRejected: confirmChangesRejected,
            onManagePermissionsFinished: managePermissionsFinished,
            onSelectedTabIndexChanged: selectedTabIndexChanged,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ManagePermissionsPage);
